export default {
  Receiving: 'Receiving',
  Returns: 'Returns'
}

